// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__25qRT","title":"ClientReferral_title__2jxfl","itemText":"ClientReferral_itemText__iJL-j"};